module.exports = __webpack_public_path__ + "p2_img3.jpg?b23371617cf146fede731575e090e89b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img3.jpg
// module id = 116
// module chunks = 0